module.exports = __webpack_public_path__ + "img/login.11bcfd8a.png";